import { Component, OnDestroy } from '@angular/core';
import { FavoriteStop, JourneyPlannerFacade } from '@ridango/components/lib/journey-planner';
import { BaseComponent } from '@ridango/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'rwidget-favorites-list-modal',
    templateUrl: './journey-planner-favorites-list-modal.component.html',
    styleUrls: ['./journey-planner-favorites-list-modal.component.scss']
})
export class JourneyPlannerFavoritesListModalComponent extends BaseComponent implements OnDestroy {
    removedFavoriteLocations: FavoriteStop[] = [];

    constructor(
        private modalCtrl: ModalController,
        private journeyPlannerFacade: JourneyPlannerFacade
    ) {
        super();
    }

    /* Hooks */
    ngOnDestroy() {
        super.ngOnDestroy();
    }

    /* Methods */
    public async cancel(): Promise<void> {
        await this.modalCtrl.dismiss(null, 'cancel');
    }

    public handleSaveClick() {
        this.journeyPlannerFacade.deleteFavoriteStops(this.removedFavoriteLocations);
        return this.modalCtrl.dismiss(null, 'cancel');
    }

    public handleRemoveFavorite(removedFavoriteLocations: FavoriteStop[]): void {
        this.removedFavoriteLocations = removedFavoriteLocations;
    }
}
